import { render } from "./InformationPage.vue?vue&type=template&id=d6582b10&scoped=true"
import script from "./InformationPage.vue?vue&type=script&lang=js"
export * from "./InformationPage.vue?vue&type=script&lang=js"

import "./InformationPage.vue?vue&type=style&index=0&id=d6582b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6582b10"]])

export default __exports__